import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

import {useMessagingContext} from '../../../useMessagingContext/index.js'
import {CardAd} from './cardAd.js'
import {modalConfig} from './config.js'

export const ReservationPaymentStatusModal = () => {
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()
  const {state: routerState} = useLocation()

  const handleConfirmButton = status => {
    setInteractionComponent({component: null, show: false})
  }

  const modalType = routerState?.pay === 'ko' ? 'failedPayment' : 'successfullPayment'
  const {notificationType, notificationText, Icon, description, title} = modalConfig[modalType]

  return (
    <MoleculeModal isOpen closeOnOutsideClick closeOnEscKeyDown iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}>
      <div className="mt-ReservationModal-modalContainer">
        <div className="mt-ReservationModal-modalContainerNotification">
          <MoleculeNotification
            alignItems={moleculeNotificationAlignItems.CENTER}
            autoClose={null}
            icon={<Icon size={ATOM_ICON_SIZES.medium} />}
            position="relative"
            roundedCorners={moleculeNotificationBorderSizes.medium}
            show
            showCloseButton={false}
            showLeftIconMobile
            type={moleculeNotificationTypes[notificationType]}
            variation={moleculeNotificationVariations.positive}
          >
            {i18n.t(notificationText)}
          </MoleculeNotification>
        </div>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: handleConfirmButton,
                  isDisabled: false,
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-ReservationModal-modalChildren">
                  <div className="mt-ReservationModal-modalConfirmationChildrenDescription">{i18n.t(description)}</div>
                  {Boolean(routerState?.adId) && <CardAd adId={routerState?.adId} />}
                </div>
              ),
              renderButtonsV2: true,
              title: i18n.t(title),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
